import api from "!../../../../../../../../style-loader-virtual-c514109e2f/0/cache/style-loader-npm-2.0.0-b9a5c4a2aa-129f8d7124.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../../css-loader-virtual-1089cffea8/0/cache/css-loader-npm-5.2.6-118c6d409e-592df1dcc7.zip/node_modules/css-loader/dist/cjs.js!../../../../../../../../less-loader-virtual-dd6fc2d730/0/cache/less-loader-npm-8.1.1-3efd61be2e-859f231d11.zip/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[6].use[2]!./index.less";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};